<template>
  <div :class="hasNotification ? 'mt-3' : 'mt-2'" class="product-type-nav-wrapper mt-md-3 bg-info">
    <div class="d-flex justify-content-around align-items-end product-type-nav">
      <b-link :to="{ name: 'TagStore' }" class="product-type-nav-item text-center" title="Tags">
        <b-img center class="product-type-nav-icon" v-bind="getIcon('tags')" alt="" />
        <div class="d-flex justify-content-center ml-md-0 mr-md-auto font-weight-bold text-secondary product-type-nav-text">Tags</div>
        <div class="active-border mt-1 mt-md-2" />
      </b-link>
      <b-link
          v-if="city.showPetTrackerInStoreForPetOwner"
          :to="{ name: 'SmartTrackerHomePageRedirect' }"
          class="product-type-nav-item text-center"
          title="Smart Tracker"
      >
        <b-img center class="product-type-nav-icon" v-bind="getIcon('smartTracker')" alt="" />
        <div class="d-flex justify-content-center ml-md-0 mr-md-auto font-weight-bold text-secondary product-type-nav-text">Smart Tracker</div>
        <div class="active-border mt-1 mt-md-2" />
      </b-link>
      <b-link
        v-if="city.showWalletCardProducts"
        :to="{ name: 'WalletCardStore' }"
        class="product-type-nav-item text-center"
        title="Wallet Cards"
      >
        <b-img center class="product-type-nav-icon" v-bind="getIcon('walletCards')" alt="" />
        <div class="d-flex justify-content-center ml-md-0 mr-md-auto font-weight-bold text-secondary product-type-nav-text">
          Wallet Cards
        </div>
        <div class="active-border mt-1 mt-md-2" />
      </b-link>
      <b-link
          v-if="city.showCollarsLeashesProducts"
          :to="{ name: 'CollarStore' }"
          class="product-type-nav-item text-center"
          title="Collars"
      >
        <b-img center class="product-type-nav-icon" v-bind="getIcon('collars')" alt="" />
        <div class="d-flex justify-content-center ml-md-0 mr-md-auto font-weight-bold text-secondary product-type-nav-text">Collars</div>
        <div class="active-border mt-1 mt-md-2" />
      </b-link>
      <b-link
        v-if="city.showPetEssentialsProducts"
        :to="{ name: 'EssentialsStore' }"
        class="product-type-nav-item text-center"
        title="Essentials"
      >
        <b-img center class="product-type-nav-icon" v-bind="getIcon('essentials')" alt="" />
        <div class="d-flex justify-content-center ml-md-0 mr-md-auto font-weight-bold text-secondary product-type-nav-text">Essentials</div>
        <div class="active-border mt-1 mt-md-2" />
      </b-link>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'ProductTypeNavbar',
  computed: {
    ...mapState({
      city: (state) => state.user.city,
      isLoggedInPetOwner: (state) => state.user.user.id && state.user.user.__typename === 'PetOwner',
    }),
    ...mapGetters({
      hasNotification: 'notification/hasNotification',
    }),
  },
  methods: {
    getIcon(iconName) {
      return {
        src: this?.$t?.(`icons.${iconName}.mobile`) || this?.$t?.(`icons.${iconName}.desktop`),
        srcset: `${this?.$t?.(`icons.${iconName}.mobile`)} 1x, ${this?.$t?.(`icons.${iconName}.desktop`)} 2x`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@docupet/component-library/src/assets/styles/_variables';
.product-type-nav-wrapper {
  background-color: $dp-white !important;
}
.product-type-nav {
  margin-left: auto;
  margin-right: auto;
  max-width: 750px;
  & .active-border {
    border-bottom: $dp-white solid 0.5rem;
  }
  & .router-link-active {
    & .active-border {
      border-bottom: $dp-light-blue solid 0.5rem;
    }
  }
}
.product-type-nav-wrapper {
  border-bottom: $dp-gray-3 solid 1px;
}
.product-type-nav-item {
  width: 25%;
}
.product-type-nav-icon {
  width: auto;
  height: 42px;

  @media (max-width: 768px) {
    width: auto;
    max-height: 28px;
  }
}
.product-type-nav-text {
  padding-top: 5px;
  @media (max-width: 450px) {
    font-size: 0.65em;
  }
}
.product-type-nav-icon {
  font-size: 3em;
  @media (max-width: 750px) {
    font-size: 2.5em;
  }
  @media (max-width: 450px) {
    font-size: 2em;
  }
}
</style>
